import { createBrowserRouter, Navigate, Outlet, redirect, RouterProvider } from 'react-router-dom';
import './App.css';
import { DashLayout } from './features/dash/layouts/DashLayout';
import { TableLayout } from './features/dash/layouts/TableLayout';
import { CalendarView } from './features/dash/views/calendar/CalendarView';
import { AddEditInvoiceClient } from './features/dash/views/client/InvoiceClients/AddEditInvoiceClient';
import { InvoiceClientDetails } from './features/dash/views/client/InvoiceClients/InvoiceClientDetails';
import { AddEditDocument } from './features/dash/views/content/Documents/AddEditDocument';
import { DocumentDetails } from './features/dash/views/content/Documents/DocumentDetails';
import { DocumentsView } from './features/dash/views/content/Documents/DocumentsView';
import { AddEditLessonPlan } from './features/dash/views/content/LessonPlans/AddEditLessonPlan';
import { LessonPlanDetails } from './features/dash/views/content/LessonPlans/LessonPlanDetails';
import { LessonPlansView } from './features/dash/views/content/LessonPlans/LessonPlansView';
import { AddEditRecipe } from './features/dash/views/content/Recipes/AddEditRecipe';
import { RecipeDetails } from './features/dash/views/content/Recipes/RecipeDetails';
import { RecipesView } from './features/dash/views/content/Recipes/RecipesView';
import { AddEditEnrollment } from './features/dash/views/enrollment/AddEditEnrollment';
import { EnrollmentDetails } from './features/dash/views/enrollment/EnrollmentDetails';
import { EnrollmentsView } from './features/dash/views/enrollment/EnrollmentsView';
import { CurrentTimesheetView } from './features/dash/views/finance/CurrentTimesheetView';
import { AddEditExpense } from './features/dash/views/finance/Expenses/AddEditExpense';
import { ExpenseDetails } from './features/dash/views/finance/Expenses/ExpenseDetails';
import { ExpensesView } from './features/dash/views/finance/Expenses/ExpensesView';
import { AddEditInvoiceItem } from './features/dash/views/finance/InvoiceItems/AddEditInvoiceItem';
import { InvoiceItemDetails } from './features/dash/views/finance/InvoiceItems/InvoiceItemDetails';
import { AddEditInvoice } from './features/dash/views/finance/Invoices/AddEditInvoice';
import { InvoiceDetails } from './features/dash/views/finance/Invoices/InvoiceDetails';
import { InvoicesView } from './features/dash/views/finance/Invoices/InvoicesView';
import { MasterTimesheetView } from './features/dash/views/finance/MasterTimesheetView';
import { OverridesView } from './features/dash/views/finance/OverridesView';
import { PastTimesheetsView } from './features/dash/views/finance/PastTimesheetsView';
import { AddEditPayment } from './features/dash/views/finance/Payments/AddEditPayment';
import { PaymentDetails } from './features/dash/views/finance/Payments/PaymentDetails';
import { PaymentsView } from './features/dash/views/finance/Payments/PaymentsView';
import { AddEditReceipt } from './features/dash/views/finance/Receipts/AddEditReceipt';
import { ReceiptDetails } from './features/dash/views/finance/Receipts/ReceiptDetails';
import { ReceiptsView } from './features/dash/views/finance/Receipts/ReceiptsView';
import { TimesheetView } from './features/dash/views/finance/TimesheetView';
import { AddEditDiscount } from './features/dash/views/orders/Discounts/AddEditDiscount';
import { DiscountDetails } from './features/dash/views/orders/Discounts/DiscountDetails';
import { DiscountsView } from './features/dash/views/orders/Discounts/DiscountsView';
import { OrderDetails } from './features/dash/views/orders/OrderDetails';
import { OrdersView } from './features/dash/views/orders/OrdersView';
import { AddEditPromotionalCode } from './features/dash/views/orders/PromotionalCodes/AddEditPromotionalCode';
import { PromotionalCodeDetails } from './features/dash/views/orders/PromotionalCodes/PromotionalCodeDetails';
import { PromotionalCodesView } from './features/dash/views/orders/PromotionalCodes/PromotionalCodesView';
import { AddEditScholarship } from './features/dash/views/orders/Scholarships/AddEditScholarship';
import { ScholarshipDetails } from './features/dash/views/orders/Scholarships/ScholarshipDetail';
import { ScholarshipsView } from './features/dash/views/orders/Scholarships/ScholarshipsView';
import { AddEditUser } from './features/dash/views/people/AddEditUser';
import { AdminsView } from './features/dash/views/people/AdminsView';
import { AddEditChild } from './features/dash/views/people/Children/AddEditChild';
import { ChildDetails } from './features/dash/views/people/Children/ChildDetails';
import { ChildrenView } from './features/dash/views/people/Children/ChildrenView';
import { InstructorsView } from './features/dash/views/people/InstructorsView';
import { ParentsView } from './features/dash/views/people/ParentsView';
import { UserDetailsView } from './features/dash/views/people/UserDetailsView';
import {
  LocationsView,
  OrganizationsView,
  VenuesView,
  ZipCodesView
} from './features/dash/views/places';
import { AddEditLocation } from './features/dash/views/places/locations/AddEditLocation';
import { LocationDetails } from './features/dash/views/places/locations/LocationDetails';
import { AddEditOrganization } from './features/dash/views/places/organizations/AddEditOrganization';
import { OrganizationDetails } from './features/dash/views/places/organizations/OrganizationDetails';
import { AddEditVenue } from './features/dash/views/places/venues/AddEditVenue';
import { VenueDetails } from './features/dash/views/places/venues/VenueDetails';
import { ClassesView } from './features/dash/views/schedule/classes/ClassesView';
import { InstructorSessionRequestView } from './features/dash/views/schedule/needs/InstructorSessionRequestView';
import { NeedSubstituteView } from './features/dash/views/schedule/needs/NeedSubstituteView';
import { NeedsView } from './features/dash/views/schedule/needs/NeedsView';
import { AddEditSession } from './features/dash/views/schedule/sessions/AddEditSession';
import { SessionDetail } from './features/dash/views/schedule/sessions/SessionDetail';
import { SessionsView } from './features/dash/views/schedule/sessions/SessionsView';
import { ArchiveWaitlist } from './features/dash/views/schedule/waitlist/ArchiveWaitlist';
import { WaitlistDetail } from './features/dash/views/schedule/waitlist/WaitlistDetails';
import { WaitlistView } from './features/dash/views/schedule/waitlist/WaitlistView';
import { AddEditFeedback } from './features/dash/views/website/Feedbacks/AddEditFeedback';
import { FeedbackDetails } from './features/dash/views/website/Feedbacks/FeedbackDetails';
import { FeedbacksView } from './features/dash/views/website/Feedbacks/FeedbacksView';
import { GalleriesView } from './features/dash/views/website/Galleries/GalleriesView';
import { AddEditNewsItem } from './features/dash/views/website/NewsItems/AddEditNewsItem';
import { NewsItemDetails } from './features/dash/views/website/NewsItems/NewsItemDetails';
import { NewsItemsView } from './features/dash/views/website/NewsItems/NewsItemsView';
import { PagesView } from './features/dash/views/website/Pages/PagesView';
import { SnippetsView } from './features/dash/views/website/Snippets/SnippetsView';
import { TeamProfilesView } from './features/dash/views/website/TeamProfiles/TeamProfilesView';
import { Error404 } from './features/errors/Error404';
import { SFCLayout } from './features/home/SFCLayout';
import ForgotPassword from './features/user/ForgotPassword';
import Login from './features/user/Login';
import Profile from './features/user/Profile';
import Register from './features/user/Register';
import ResetPassword from './features/user/ResetPassword';
import { UserLayout } from './features/user/UserLayout';
import { UserProfileLayout } from './features/user/UserProfileLayout';
import { Welcome } from './features/user/Welcome';
import { getCurrentUser, isAuthenticated } from './services/helper';
import { isWebContentEditor } from './utils/consts';
// import { FranchiseeLeadsView } from './features/dash/views/website/FranchiseeLeads/FranchiseeLeadsView';
// import { AddEditFranchiseeLead } from './features/dash/views/website/FranchiseeLeads/AddEditFranchiseeLead';
// import { FranchiseeLeadDetails } from './features/dash/views/website/FranchiseeLeads/FranchiseeLeadDetails';
import { AvailableJobsSection } from './features/availableJobs/AvailableJobsSection';
import { ContentVideosView } from './features/dash/views/content/ContentVideos/ContentVideoView';
import { AddEditCountryFacts } from './features/dash/views/content/CountryFacts/AddEditCountryFact';
import { CountryFacttDetails } from './features/dash/views/content/CountryFacts/CountryFactDetails';
import { CountryFactsView } from './features/dash/views/content/CountryFacts/CountryFactsView';
import { AddEditFeaturedIngredient } from './features/dash/views/content/FeaturedIngredients/AddEditFeaturedIngredient';
import { FeaturedIngredientDetails } from './features/dash/views/content/FeaturedIngredients/FeaturedIngredientsDetails';
import { FeaturedIngredientsView } from './features/dash/views/content/FeaturedIngredients/FeaturedIngredientsView';
import { AddEditFoodHistories } from './features/dash/views/content/FoodHistories/AddEditFoodHistory';
import { FoodHistoriesView } from './features/dash/views/content/FoodHistories/FoodHistoriesView';
import { FoodHistoryDetails } from './features/dash/views/content/FoodHistories/FoodHistoryDetails';
import { AddEditJokeCategory } from './features/dash/views/content/JokeCategories/AddEditJokeCategory';
import { JokeCategoriesView } from './features/dash/views/content/JokeCategories/JokeCategoriesView';
import { JokeCategoryDetails } from './features/dash/views/content/JokeCategories/JokeCategoryDetails';
import { AddEditJoke } from './features/dash/views/content/Jokes/AddEditJoke';
import { JokeDetails } from './features/dash/views/content/Jokes/JokeDetails';
import { JokesView } from './features/dash/views/content/Jokes/JokesView';
import { AddEditKitchenSkills } from './features/dash/views/content/KitchenSkills/AddEditKitchenSkill';
import { KitchenSkillsDetails } from './features/dash/views/content/KitchenSkills/KitchenSkillDetails';
import { KitchenSkillsView } from './features/dash/views/content/KitchenSkills/KitchenSkillsView';
import { AddEditQuestions } from './features/dash/views/content/Questions/AddEditQuestion';
import { QuestionsDetails } from './features/dash/views/content/Questions/QuestionDetails';
import { QuestionsView } from './features/dash/views/content/Questions/QuestionsView';
import { AddEditTheme } from './features/dash/views/content/Themes/AddEditTheme';
import { ThemeDetails } from './features/dash/views/content/Themes/ThemesDetails';
import { ThemesView } from './features/dash/views/content/Themes/ThemesView';
// import { CurrentEntriesView } from './features/dash/views/finance/CurrentEntries/CurrentEntriesView';
import { InvoicerView } from './features/dash/views/finance/Invoicer/InvoicerView';
import { InvoicesClientView } from './features/dash/views/finance/Invoices/InvoiceClients';
import { PowerBiView } from './features/dash/views/finance/PowerBi/PowerBiView';
import { RefundDetails } from './features/dash/views/orders/Refunds/RefundDetails';
import { RefundsView } from './features/dash/views/orders/Refunds/RefundsView';
import { AddEditAllergy } from './features/dash/views/people/Allergy/AddEditAllergy';
import { AllergiesView } from './features/dash/views/people/Allergy/AllergiesView';
import { AllergyDetails } from './features/dash/views/people/Allergy/AllergyDetails';
import { WaiverDetails } from './features/dash/views/people/Waiver/WaiverDetails';
import {userCanView_Waviers, WaiversView} from './features/dash/views/people/Waiver/WaiversView';
import { ResourceLedger } from './features/dash/views/places/common/ResourceLedger';
import { LocationWeeklyReport } from './features/dash/views/places/locations/LocationWeeklyReport';
import { AddEditTerritory } from './features/dash/views/places/territories/AddEditTerritory';
import { TerritoriesView } from './features/dash/views/places/territories/TerritoriesView';
import { TerritoryDetails } from './features/dash/views/places/territories/TerritoryDetails';
import { SessionWaitlist } from './features/dash/views/schedule/sessions/SessionWaitlist';
import { AddEditRegistrations } from './features/dash/views/sessions/Registrations/AddEditRegistration';
import { RegistrationsDetails } from './features/dash/views/sessions/Registrations/RegistrationDetails';
import { RegistrationsView } from './features/dash/views/sessions/Registrations/RegistrationsView';
import { AddEditTrainingVideos } from './features/dash/views/training/TrainingVideo/AddEditTrainingVideo';
import { TrainingVideosDetails } from './features/dash/views/training/TrainingVideo/TrainingVideoDetails';
import { TrainingVideosView } from './features/dash/views/training/TrainingVideo/TrainingVideosView';
import { AddEditGallery } from './features/dash/views/website/Galleries/AddEditGallery';
import { GalleryDetails } from './features/dash/views/website/Galleries/GalleryDetails';
import { AddEditPage } from './features/dash/views/website/Pages/AddEditPage';
import { PageDetails } from './features/dash/views/website/Pages/PageDetails';
import { AddEditSnippet } from './features/dash/views/website/Snippets/AddEditSnippet';
import { SnippetDetails } from './features/dash/views/website/Snippets/SnippetDetails';
import { AddEditTeamProfile } from './features/dash/views/website/TeamProfiles/AddEditTeamProfile';
import { TeamProfileDetails } from './features/dash/views/website/TeamProfiles/TeamProfileDetails';
import { FAQsPage } from './features/faqs/FAQsPage';
import { FranchiseLayout } from './features/franchise/FranchiseLayout';
import Checkout from './features/home/cart/Checkout';
import { HomeSection } from './features/home/HomeSection';
import Recipes from './features/home/recipes/Recipes';
import CourseSearch from './features/home/search/CourseSearch';
import CourseDetails from './features/home/search/details/CourseDetails';
import SingleRecipe from './features/home/SingleRecipe/SingleRecipe';
import { MediaInquiriesSection } from './features/mediaInquiries/MediaInquiriesSection';
import { NationwideSection } from './features/nationwide/NationwideSection';
import { OurCrewPage } from './features/home/OurCrew/OurCrewPage';
import { StickyNotesSection } from './features/stickyNotes/StickyNotes';
import { StickyNoteDetails } from './features/stickyNotes/StickyNoteDetails';
import AddChild from './features/user/AddChild';
import ClassDetailsRecipes from './features/user/ClassDetailsRecipes/ClassDetailsRecipes';
import { ContactForm } from './features/user/ContactForm';
import Favorites from './features/user/Favorites';
import Orders from './features/user/Orders';
import { PublicWaiverForm } from './features/waiver/PublicWaiverForm';
import { WhyWeAreGrateSection } from './features/whyWeAreGrate/whyWeAreGrateSection';
import { useGetLocationLedgerQuery } from './services/endpoints/places/location';
import { useGetTerritoryLedgerQuery } from './services/endpoints/places/territory';
import { useGetVenueLedgerQuery } from './services/endpoints/places/venue';
import { useGetCourseLedgerQuery } from './services/endpoints/schedule/course';
import {
  getAllowedTabsContent,
  getAllowedTabsFinance,
  getAllowedTabsOrders,
  getAllowedTabsPeople_DashUsers,
  getAllowedTabsPeople_SFCUsers,
  getAllowedTabsPlaces,
  getAllowedTabsSchedule_ScheduleNeeds,
  getAllowedTabsSchedule_SessionsClasses,
  getAllowedTabsTimesheets,
  getAllowedTabsTraining,
  getAllowedTabsWebsite
} from './utils/utils';
import FamilyCookingClasses from "./features/home/privateEvents/FamilyCookingClasses";
import GirlScouts from "./features/home/privateEvents/GirlScouts";
import CorporateEvents from "./features/home/privateEvents/CorporateEvents";
import BirthdayParties from "./features/home/privateEvents/BirthdayParties";
import { LegacyCoursesRedirect, LegacySessionRedirect, LegacyPageRedirect, LegacyAdminSessionRedirect, FranchiseSlugRedirect } from './features/redirects/LegacyRedirects';

const currentUser = getCurrentUser();
// Load your Stripe public key

// Used for routes that require authentication
const ProtectedRoute = ({ isAuthenticated }: { isAuthenticated: boolean }) => {
  const isPublicInvoicePage = window.location.pathname.includes('/finance/invoice_client/');
  if (!isAuthenticated && !isPublicInvoicePage) {
    return (
      <Navigate
        to="/"
        replace
      />
    );
  }
  return <Outlet />;
};

const contentTabs = getAllowedTabsContent(currentUser);
const placesTabs = getAllowedTabsPlaces(currentUser);
const trainingTabs = getAllowedTabsTraining(currentUser);
const websiteTabs = getAllowedTabsWebsite(currentUser);
const sessionsClassesTabs = getAllowedTabsSchedule_SessionsClasses(currentUser);
const scheduleNeedsTabs = getAllowedTabsSchedule_ScheduleNeeds(currentUser);
const dashUsersTabs = getAllowedTabsPeople_DashUsers(currentUser);
const sfcUsersTabs = getAllowedTabsPeople_SFCUsers(currentUser);
const financeTabs = getAllowedTabsFinance(currentUser);
const timesheetsTabs = getAllowedTabsTimesheets(currentUser);
const ordersTabs = getAllowedTabsOrders(currentUser);

const router = createBrowserRouter([
  // TODO: change home page component, using dash layout as of now for testing without authentication
  {
    path: '/',
    element: <SFCLayout />,
    errorElement: <Error404 />,
    children: [
      {
        path: 'sessions',
        element: <CourseSearch />
      },
      {
        path: 'sessions/:id',
        element: <CourseDetails />,
        loader: () => ({ message: 'CourseDetails...loading' })
      },
      { path: 'courses', element: <LegacyCoursesRedirect /> },
      { path: 'school-programs', element: <Navigate to="/sessions?session_type=after_school" replace /> },
      { path: 'school-programs/:location/:slug', element: <LegacySessionRedirect /> },
      { path: 'camps', element: <Navigate to="/sessions?session_type=camps" replace /> },
      { path: 'camps/:location/:slug', element: <LegacySessionRedirect /> },
      { path: 'pages/:slug', element: <LegacyPageRedirect /> },
      { path: 'private-events', element: <Navigate to="/why-we-are-grate#private-events" replace /> },
      { path: 'how-to-enroll-in-online-classes', element: <Navigate to="/why-we-are-grate#online" replace /> },
      { path: 'account', element: <Navigate to="/user/class-details-recipes" replace /> },

      {
        path: 'waivers/new',
        element: <PublicWaiverForm />
      },
      {
        path: 'why-we-are-grate',
        element: <WhyWeAreGrateSection />,
        loader: () => ({ message: 'Why we are grate ...loading' })
      },
      {
        path: 'why-we-are-grape',
        element: (
          <Navigate
            to="/why-we-are-grate"
            replace
          />
        )
      },
      {
        path: 'contact',
        element: <ContactForm />
      },
      {
        path: 'franchise/:slug',
        element: (
          <FranchiseSlugRedirect>
            <FranchiseLayout />
          </FranchiseSlugRedirect>
        ),
        loader: () => ({ message: 'Franchise...loading' }),
      },
      {
        path: 'nationwide',
        element: <NationwideSection />,
        loader: () => ({ message: 'Nationwide map ...loading' })
      },
      {
        path: 'availableJobs',
        element: <AvailableJobsSection />,
        loader: () => ({ message: 'Available Jobs ...loading' })
      },
      {
        path: 'media-inquiries',
        element: <MediaInquiriesSection />,
        loader: () => ({ message: 'Media Inquiries ...loading' })
      },
      {
        path: 'about/our-crew',
        element: <OurCrewPage />,
        loader: () => ({ message: 'Our Crew ...loading' })
      },
      {
        path: 'sticky-notes',
        element: <StickyNotesSection />,
        loader: () => ({ message: 'Sticky notes ...loading' })
      },
      {
        path: 'sticky-notes/:slug',
        element: <StickyNoteDetails />,
        loader: () => ({ message: 'Sticky note...loading' }),
      },
      {
        path: 'school-programs/faqs',
        element: <FAQsPage />,
        loader: () => ({ message: 'FAQs ...loading' })
      },

      {
        path: '',
        element: <HomeSection />,
        loader: () => ({ message: 'Home...loading' })
      },
      {
        path: 'cart',
        element: <Checkout />,
        loader: () => ({ message: 'Checkout...loading' })
      },
      {
        path: 'recipes',
        element: <Recipes />,
        loader: () => ({ message: 'Recipes...loading' })
      },
      {
        path: 'recipes/:slug',
        element: <SingleRecipe />,
        loader: () => ({ message: 'Recipes...loading' })
      },
      {
        path: 'lesson-plans/:id',
        element: <SingleRecipe isLessonPlan={true} />,
        loader: () => ({ message: 'Lesson Plan...loading' })
      },
      {
        path: 'lesson_plans/:slug',
        loader: ({ params }) => redirect(`/lesson-plans/${params.slug}`)
      },
      {
        path: 'birthday-parties',
        element: <BirthdayParties />
      },
      {
        path: 'girl-scouts-and-boy-scouts',
        element: <GirlScouts />
      },
      {
        path: 'family-cooking-classes',
        element: <FamilyCookingClasses />
      },
      {
        path: 'corporate-events',
        element: <CorporateEvents />
      }
    ]
  },
  {
    element: <ProtectedRoute isAuthenticated={isAuthenticated()} />, // Protected route that requires authentication
    errorElement: <Error404 />,
    children: [
      {
        path: '/',
        element: <SFCLayout />,
        children: [
          {
            path: 'user',
            element: (
              <UserProfileLayout
                  tabs={[
                    { title: 'Profile', url: '/user/profile' },
                    { title: 'My Recipes', url: '/user/favorites' },
                    { title: 'My Orders', url: '/user/orders' },
                    {
                      title: 'Class Details & Recipes',
                      url: '/user/class-details-recipes'
                    }
                  ]}
              />
            ),
            loader: () => ({ message: 'Profile...loading' }),
            children: [
              {
                path: 'profile',
                element: <Profile />,
                loader: () => ({ message: 'Profile...loading' })
              },
              {
                path: 'orders',
                element: <Orders />,
                loader: () => ({ message: 'Orders...loading' })
              },
              {
                path: 'class-details-recipes',
                element: <ClassDetailsRecipes />,
                loader: () => ({
                  message: 'Class Details & Recipes...loading'
                })
              },
              {
                path: 'class-details-recipes/:date',
                element: <ClassDetailsRecipes />,
                loader: () => ({
                  message: 'Class Details & Recipes...loading'
                })
              },
              {
                path: 'favorites',
                element: <Favorites />,
                loader: () => ({ message: 'Favorites...loading' })
              }
            ]
          },
          {
            path: 'children',
            element: (
              <UserProfileLayout
                tabs={[]}
                showTitle={false}
              />
            ),
            loader: () => ({ message: 'Children...loading' }),
            children: [
              {
                index: true,
                element: <Navigate to="/user/profile" replace />
              },
              {
                path: 'new',
                element: <AddChild />,
                loader: () => ({ message: 'Add Children...loading' })
              },
              {
                path: ':id/edit',
                element: <AddChild editing />
              }
            ]
          }
        ]
      },
      {
        path: 'admin',
        element: <DashLayout />,
        loader: () => ({ message: 'Dash...loading' }),
        children: [
          {
            path: 'dashboard',
            element: <CalendarView />,
            loader: () => ({ message: 'Calendar...loading' })
          },
          { path: 'sessions/:slug', element: <LegacyAdminSessionRedirect /> },
          {
            path: 'enrollments',
            element: (
              <TableLayout
                title="Enrollments"
                tabs={[]}
              />
            ),
            children: [{ path: '', element: <EnrollmentsView /> }]
          },
          {
            path: 'enrollments',
            element: <Outlet />,
            children: [
              { path: 'new/:parent_courceId', element: <AddEditEnrollment /> },
              { path: 'new', element: <AddEditEnrollment /> },
              { path: ':id/edit', element: <AddEditEnrollment editing /> },
              { path: ':id', element: <EnrollmentDetails /> }
            ]
          },
          {
            path: 'registrations',
            element: (
              <TableLayout
                title="Registrations"
                tabs={[]}
              />
            ),
            loader: () => ({ message: 'Registrations...loading' }),
            children: [{ path: '', element: <RegistrationsView /> }]
          },
          {
            path: 'registrations',
            element: <Outlet />,
            loader: () => ({ message: 'Registrations...loading' }),
            children: [
              { path: 'new', element: <AddEditRegistrations /> },
              { path: ':id/edit', element: <AddEditRegistrations editing /> },
              { path: ':id', element: <RegistrationsDetails /> }
            ]
          },
          {
            path: 'schedule',
            element: (
              <TableLayout
                title="Sessions & Classes"
                tabs={sessionsClassesTabs}
              />
            ),
            loader: () => ({ message: 'Schedule...loading' }),
            children: [
              { path: 'sessions', element: <SessionsView /> },
              { path: 'classes', element: <ClassesView /> },
              { path: 'waitlists', element: <WaitlistView /> }
            ]
          },
          {
            path: 'schedule/sessions',
            element: <Outlet />,
            loader: () => ({ message: 'Sessions...loading' }),
            children: [
              { path: 'new', element: <AddEditSession /> },
              { path: ':id/edit', element: <AddEditSession editing /> },
              { path: ':id', element: <SessionDetail /> },
              { path: ':id/waitlist/:action', element: <SessionWaitlist /> },
              { path: 'invoicer/:id', element: <InvoicerView /> },
              {
                path: ':id/ledger',
                element: (
                  <ResourceLedger
                    resource="sessions"
                    resourcePlural="sessions"
                    resourcePath="schedule"
                    noFilters={true}
                    ledgerQuery={useGetCourseLedgerQuery}
                  />
                )
              }
            ]
          },
          {
            path: 'schedule/waitlists',
            element: <Outlet />,
            loader: () => ({ message: 'Waitlists...loading' }),
            children: [
              { path: ':id', element: <WaitlistDetail /> },
              { path: ':id/archive', element: <ArchiveWaitlist /> }
            ]
          },
          {
            path: 'schedule-needs',
            element: (
              <TableLayout
                title="Schedule Needs"
                tabs={scheduleNeedsTabs}
              />
            ),
            loader: () => ({ message: 'Schedule Needs...loading' }),
            children: [
              { path: 'need-instructor', element: <NeedsView /> },
              { path: 'need-substitute', element: <NeedSubstituteView /> },
              {
                path: 'instructor-session-requests',
                element: <InstructorSessionRequestView />
              }
            ]
          },
          {
            path: 'dash-users',
            element: (
              <TableLayout
                title="Dash Users"
                tabs={dashUsersTabs}
              />
            ),
            loader: () => ({ message: 'Dash Users...loading' }),
            children: [
              { path: 'admins', element: <AdminsView /> },
              { path: 'instructors', element: <InstructorsView /> },
              {
                path: '',
                element: (
                  <Navigate
                    to="instructors"
                    replace
                  />
                )
              }
            ]
          },
          {
            path: 'dash-users/admins',
            element: <Outlet />,
            loader: () => ({ message: 'Admins...loading' }),
            children: [
              { path: 'new', element: <AddEditUser userType="admin" /> },
              {
                path: ':id/edit',
                element: (
                  <AddEditUser
                    editing
                    userType="admin"
                  />
                )
              },
              { path: ':id', element: <UserDetailsView userType="admin" /> }
            ]
          },
          {
            path: 'dash-users/instructors',
            element: <Outlet />,
            loader: () => ({ message: 'Instructors...loading' }),
            children: [
              { path: 'new', element: <AddEditUser userType="instructor" /> },
              {
                path: ':id/edit',
                element: (
                  <AddEditUser
                    editing
                    userType="instructor"
                  />
                )
              },
              {
                path: ':id',
                element: <UserDetailsView userType="instructor" />
              }
            ]
          },
          {
            path: 'sfc-users',
            element: (
              <TableLayout
                title="SFC Users"
                tabs={sfcUsersTabs}
              />
            ),
            loader: () => ({ message: 'Dash Users...loading' }),
            children: [
              { path: 'parents', element: <ParentsView /> },
              { path: 'children', element: <ChildrenView /> },
              {
                path: '',
                element: (
                  <Navigate
                    to="parents"
                    replace
                  />
                )
              }
            ]
          },
          {
            path: 'sfc-users/parents',
            element: <Outlet />,
            loader: () => ({ message: 'Parents...loading' }),
            children: [
              { path: 'new', element: <AddEditUser userType="customer" /> },
              {
                path: ':id/edit',
                element: (
                  <AddEditUser
                    editing
                    userType="customer"
                  />
                )
              },
              { path: ':id', element: <UserDetailsView userType="customer" /> }
            ]
          },
          {
            path: 'sfc-users/children',
            element: <Outlet />,
            loader: () => ({ message: 'Children...loading' }),
            children: [
              { path: 'new', element: <AddEditChild /> },
              { path: ':id/edit', element: <AddEditChild editing /> },
              { path: ':id', element: <ChildDetails /> }
            ]
          },
          {
            path: 'allergies',
            element: (
              <TableLayout
                title="SFC Users"
                tabs={[
                  { title: 'Parents', url: '/admin/sfc-users/parents' },
                  { title: 'Children', url: '/admin/sfc-users/children' },
                  {
                    title: 'Allergies',
                    url: '/admin/allergies',
                    hidden: !userCanView_Waviers(currentUser)
                  },
                  {
                    title: 'Waivers',
                    url: '/admin/waivers',
                    hidden: !userCanView_Waviers(currentUser)
                  }
                ]}
              />
            ),
            loader: () => ({ message: 'Allergies...loading' }),
            children: [{ path: '', index: true, element: <AllergiesView /> }]
          },
          {
            path: 'allergies/',
            element: <Outlet />,
            loader: () => ({ message: 'Allergies...loading' }),
            children: [
              { path: 'new', element: <AddEditAllergy /> },
              { path: ':id/edit', element: <AddEditAllergy editing /> },
              { path: ':id', element: <AllergyDetails /> }
            ]
          },
          {
            path: 'waivers',
            element: (
              <TableLayout
                title="SFC Users"
                tabs={[
                  { title: 'Parents', url: '/admin/sfc-users/parents' },
                  { title: 'Children', url: '/admin/sfc-users/children' },
                  {
                    title: 'Allergies',
                    url: '/admin/allergies',
                    hidden: !currentUser?.isSuper
                  },
                  {
                    title: 'Waivers',
                    url: '/admin/waivers',
                    hidden: !userCanView_Waviers(currentUser)
                  }
                ]}
              />
            ),
            loader: () => ({ message: 'Waivers...loading' }),
            children: [{ path: '', index: true, element: <WaiversView /> }]
          },

          {
            path: 'waivers/',
            element: <Outlet />,
            loader: () => ({ message: 'Waivers...loading' }),
            children: [{ path: ':id', element: <WaiverDetails /> }]
          },
          {
            path: 'invoice-clients',
            element: <Outlet />,
            loader: () => ({ message: 'Invoice Clients...loading' }),
            children: [
              // { path: '/', element: <InvoiceClientsView /> },
              { path: ':id/edit', element: <AddEditInvoiceClient editing /> },
              { path: ':id', element: <InvoiceClientDetails /> }
            ]
          },
          {
            path: 'content',
            element: (
              <TableLayout
                title="Content"
                tabs={contentTabs}
              />
            ),
            loader: () => ({ message: 'Documents...loading' }),
            children: [
              { path: 'lesson-plans', element: <LessonPlansView /> },
              { path: 'recipes', element: <RecipesView /> },
              { path: 'documents', element: <DocumentsView /> },
              { path: 'videos', element: <ContentVideosView /> },
              { path: 'themes', element: <ThemesView /> },
              { path: 'jokes', element: <JokesView /> },
              { path: 'joke-categories', element: <JokeCategoriesView /> },
              {
                path: 'featured-ingredients',
                element: <FeaturedIngredientsView />
              },
              { path: 'country-facts', element: <CountryFactsView /> },
              { path: 'food-histories', element: <FoodHistoriesView /> },
              { path: 'kitchen-skills', element: <KitchenSkillsView /> },
              { path: 'questions', element: <QuestionsView /> }
            ]
          },
          {
            path: 'content/lesson-plans',
            element: <Outlet />,
            loader: () => ({ message: 'Lesson plans...loading' }),
            children: [
              { path: 'new', element: <AddEditLessonPlan /> },
              { path: ':id/edit', element: <AddEditLessonPlan editing /> },
              { path: ':id', element: <LessonPlanDetails /> }
            ]
          },
          {
            path: 'content/documents',
            element: <Outlet />,
            loader: () => ({ message: 'Documents...loading' }),
            children: [
              { path: 'new', element: <AddEditDocument /> },
              { path: ':id/edit', element: <AddEditDocument editing /> },
              { path: ':id', element: <DocumentDetails /> }
            ]
          },
          {
            path: 'content/themes',
            element: <Outlet />,
            loader: () => ({ message: 'Themes...loading' }),
            children: [
              { path: 'new', element: <AddEditTheme /> },
              { path: ':id/edit', element: <AddEditTheme editing /> },
              { path: ':id', element: <ThemeDetails /> }
            ]
          },
          {
            path: 'content/recipes',
            element: <Outlet />,
            loader: () => ({ message: 'Expenses...loading' }),
            children: [
              { path: 'new', element: <AddEditRecipe /> },
              { path: ':id/edit', element: <AddEditRecipe editing={true} /> },
              { path: ':id', element: <RecipeDetails /> }
            ]
          },
          {
            path: 'content/jokes',
            element: <Outlet />,
            loader: () => ({ message: 'Jokes...loading' }),
            children: [
              { path: 'new', element: <AddEditJoke /> },
              { path: ':id/edit', element: <AddEditJoke editing /> },
              { path: ':id', element: <JokeDetails /> }
            ]
          },
          {
            path: 'content/joke-categories',
            element: <Outlet />,
            loader: () => ({ message: 'Joke Categories...loading' }),
            children: [
              { path: 'new', element: <AddEditJokeCategory /> },
              { path: ':id/edit', element: <AddEditJokeCategory editing /> },
              { path: ':id', element: <JokeCategoryDetails /> }
            ]
          },
          {
            path: 'content/featured-ingredients',
            element: <Outlet />,
            loader: () => ({ message: 'Featured ingredients...loading' }),
            children: [
              { path: 'new', element: <AddEditFeaturedIngredient /> },
              {
                path: ':id/edit',
                element: <AddEditFeaturedIngredient editing />
              },
              { path: ':id', element: <FeaturedIngredientDetails /> }
            ]
          },
          {
            path: 'content/country-facts',
            element: <Outlet />,
            loader: () => ({ message: 'Country Facts...loading' }),
            children: [
              { path: 'new', element: <AddEditCountryFacts /> },
              { path: ':id/edit', element: <AddEditCountryFacts editing /> },
              { path: ':id', element: <CountryFacttDetails /> }
            ]
          },
          {
            path: 'content/food-histories',
            element: <Outlet />,
            loader: () => ({ message: 'Food histories...loading' }),
            children: [
              { path: 'new', element: <AddEditFoodHistories /> },
              { path: ':id/edit', element: <AddEditFoodHistories editing /> },
              { path: ':id', element: <FoodHistoryDetails /> }
            ]
          },
          {
            path: 'content/kitchen-skills',
            element: <Outlet />,
            loader: () => ({ message: 'Kitchen Skills...loading' }),
            children: [
              { path: 'new', element: <AddEditKitchenSkills /> },
              { path: ':id/edit', element: <AddEditKitchenSkills editing /> },
              { path: ':id', element: <KitchenSkillsDetails /> }
            ]
          },
          {
            path: 'content/questions',
            element: <Outlet />,
            loader: () => ({ message: 'Questions...loading' }),
            children: [
              { path: 'new', element: <AddEditQuestions /> },
              { path: ':id/edit', element: <AddEditQuestions editing /> },
              { path: ':id', element: <QuestionsDetails /> }
            ]
          },
          {
            path: 'finance',
            element: (
              <TableLayout
                title="Finance"
                tabs={financeTabs}
              />
            ),
            loader: () => ({ message: 'Finance...loading' }),
            children: [
              { path: 'invoices', element: <InvoicesView /> },
              { path: 'expenses', element: <ExpensesView /> },
              { path: 'receipts', element: <ReceiptsView /> },
              { path: 'payments', element: <PaymentsView /> },
              { path: 'powerBi', element: <PowerBiView /> },
              // { path: 'current-entries', element: <CurrentEntriesView /> }
            ]
          },
          {
            path: 'finance/invoices',
            element: <Outlet />,
            loader: () => ({ message: 'Invoices...loading' }),
            children: [
              { path: ':id/edit', element: <AddEditInvoice editing /> },
              { path: ':id', element: <InvoiceDetails /> }
            ]
          },
          {
            path: 'finance/invoice_client',
            element: <Outlet />,
            loader: () => ({ message: 'Invoices...loading' }),
            children: [
              // { path: ":id/edit", element: <AddEditInvoice editing /> },
              { path: ':id', element: <InvoicesClientView /> },
              { path: ':id/:access_code', element: <InvoicesClientView /> }
            ]
          },
          {
            path: 'finance/invoice-items',
            element: <Outlet />,
            loader: () => ({ message: 'Invoice Items...loading' }),
            children: [
              { path: 'new', element: <AddEditInvoiceItem /> },
              { path: ':id/edit', element: <AddEditInvoiceItem editing /> },
              { path: ':id', element: <InvoiceItemDetails /> }
            ]
          },
          {
            path: 'finance/expenses',
            element: <Outlet />,
            loader: () => ({ message: 'Expenses...loading' }),
            children: [
              { path: 'new', element: <AddEditExpense /> },
              { path: ':id/edit', element: <AddEditExpense editing /> },
              { path: ':id', element: <ExpenseDetails /> }
            ]
          },
          {
            path: 'finance/receipts',
            element: <Outlet />,
            loader: () => ({ message: 'Receipts...loading' }),
            children: [
              { path: 'new', element: <AddEditReceipt /> },
              { path: ':id/edit', element: <AddEditReceipt editing /> },
              { path: ':id', element: <ReceiptDetails /> }
            ]
          },
          {
            path: 'finance/payments',
            element: <Outlet />,
            loader: () => ({ message: 'Payments...loading' }),
            children: [
              { path: 'new', element: <AddEditPayment newPayment /> },
              { path: 'new/:invoice_id', element: <AddEditPayment /> },
              { path: ':id/edit', element: <AddEditPayment editing /> },
              { path: ':id', element: <PaymentDetails /> }
            ]
          },
          {
            path: 'finance/powerBi',
            element: <Outlet />,
            loader: () => ({ message: 'PowerBi...loading' })
          },
          {
            path: 'timesheets',
            element: (
              <TableLayout
                title="Timesheets"
                tabs={timesheetsTabs}
              />
            ),
            loader: () => ({ message: 'Timesheets...loading' }),
            children: [
              { path: 'master-timesheet', element: <MasterTimesheetView /> },
              { path: 'current-timesheet', element: <CurrentTimesheetView /> },
              { path: 'past-timesheets', element: <PastTimesheetsView /> },
              { path: 'timesheet-overrides', element: <OverridesView /> },
              {
                path: 'timesheet-entries',
                element: <Outlet />,
                children: [{ path: ':timesheetId', element: <TimesheetView /> }]
              }
            ]
          },
          {
            path: 'orders',
            element: (
              <TableLayout
                title="Orders"
                tabs={ordersTabs}
              />
            ),
            loader: () => ({ message: 'Orders...loading' }),
            children: [
              { path: 'orders', element: <OrdersView /> },
              { path: 'refunds', element: <RefundsView /> },
              { path: 'scholarships', element: <ScholarshipsView /> },
              { path: 'discounts', element: <DiscountsView /> },
              { path: 'promotional-codes', element: <PromotionalCodesView /> }
            ]
          },
          {
            path: 'orders/orders',
            element: <Outlet />,
            loader: () => ({ message: 'Orders...loading' }),
            children: [
              { path: 'new', element: <AddEditScholarship /> },
              { path: ':id/edit', element: <AddEditScholarship editing /> },
              { path: ':id', element: <OrderDetails /> }
            ]
          },
          {
            path: 'orders/refunds',
            element: <Outlet />,
            loader: () => ({ message: 'Refund...loading' }),
            children: [{ path: ':id', element: <RefundDetails /> }]
          },
          {
            path: 'orders/scholarships',
            element: <Outlet />,
            loader: () => ({ message: 'Scholarships...loading' }),
            children: [
              { path: 'new', element: <AddEditScholarship /> },
              { path: ':id/edit', element: <AddEditScholarship editing /> },
              { path: ':id', element: <ScholarshipDetails /> }
            ]
          },
          {
            path: 'orders/discounts',
            element: <Outlet />,
            loader: () => ({ message: 'Discounts...loading' }),
            children: [
              { path: 'new', element: <AddEditDiscount /> },
              { path: ':id/edit', element: <AddEditDiscount editing /> },
              { path: ':id', element: <DiscountDetails /> }
            ]
          },
          {
            path: 'orders/promotional-codes',
            element: <Outlet />,
            loader: () => ({ message: 'Promotional Codes...loading' }),
            children: [
              { path: 'new', element: <AddEditPromotionalCode /> },
              { path: ':id/edit', element: <AddEditPromotionalCode editing /> },
              { path: ':id', element: <PromotionalCodeDetails /> }
            ]
          },
          {
            path: 'places',
            element: (
              <TableLayout
                title="Places"
                tabs={placesTabs}
              />
            ),
            loader: () => ({ message: 'Places...loading' }),
            children: [
              { path: 'venues', element: <VenuesView /> },
              { path: 'locations', element: <LocationsView /> },
              { path: 'territories', element: <TerritoriesView /> },
              { path: 'organizations', element: <OrganizationsView /> },
              { path: 'zip-codes', element: <ZipCodesView /> }
            ]
          },
          {
            path: 'places/venues',
            element: <Outlet />,
            loader: () => ({ message: 'Venues...loading' }),
            children: [
              { path: 'new', element: <AddEditVenue /> },
              { path: ':id/edit', element: <AddEditVenue editing /> },
              { path: ':id', element: <VenueDetails /> },
              {
                path: ':id/ledger',
                element: (
                  <ResourceLedger
                    resource="venue"
                    resourcePlural="venues"
                    noFilters={true}
                    ledgerQuery={useGetVenueLedgerQuery}
                  />
                )
              }
            ]
          },
          {
            path: 'places/locations',
            element: <Outlet />,
            loader: () => ({ message: 'Locations...loading' }),
            children: [
              { path: 'new', element: <AddEditLocation /> },
              { path: ':id/edit', element: <AddEditLocation editing /> },
              {
                path: ':id/ledger',
                element: (
                  <ResourceLedger
                    resource="location"
                    resourcePlural="locations"
                    ledgerQuery={useGetLocationLedgerQuery}
                    showClaimedStats={true}
                  />
                )
              },
              { path: ':id/weekly-report', element: <LocationWeeklyReport /> },
              { path: ':id', element: <LocationDetails /> }
            ]
          },

          {
            path: 'places/territories',
            element: <Outlet />,
            loader: () => ({ message: 'Territories...loading' }),
            children: [
              ...(currentUser?.isSuper
                ? [
                    { path: 'new', element: <AddEditTerritory /> },
                    { path: ':id/edit', element: <AddEditTerritory editing /> }
                  ]
                : []),
              {
                path: ':id/ledger',
                element: (
                  <ResourceLedger
                    resource="territory"
                    resourcePlural="territories"
                    ledgerQuery={useGetTerritoryLedgerQuery}
                  />
                )
              },
              // { path: ":id/weekly-report", element: <TerritoryWeeklyReport /> },
              { path: ':id', element: <TerritoryDetails /> }
            ]
          },
          {
            path: 'places/organizations',
            element: <Outlet />,
            loader: () => ({ message: 'Organizations...loading' }),
            children: [
              { path: 'new', element: <AddEditOrganization /> },
              { path: ':id/edit', element: <AddEditOrganization editing /> },
              { path: ':id', element: <OrganizationDetails /> }
            ]
          },
          {
            path: 'training',
            element: (
              <TableLayout
                title="Training"
                tabs={trainingTabs}
              />
            ),
            loader: () => ({ message: 'Documents...loading' }),
            children: [
              // { path: "Guides", element: <GuidesView /> },
              // { path: "Steps", element: <StepsView /> },
              { path: 'Videos', element: <TrainingVideosView /> }
            ]
          },
          // {
          //   path: "training/guides",
          //   element: <Outlet />,
          //   loader: () => ({ message: "Guides...loading" }),
          //   children: [
          //     { path: "new", element: <AddEditGuides /> },
          //     { path: ":id/edit", element: <AddEditGuides editing /> },
          //     { path: ":id", element: <GuidesDetails /> },
          //   ],
          // },
          // {
          //   path: "training/steps",
          //   element: <Outlet />,
          //   loader: () => ({ message: "Steps...loading" }),
          //   children: [
          //     { path: "new", element: <AddEditSteps /> },
          //     { path: ":id/edit", element: <AddEditSteps editing /> },
          //     { path: ":id", element: <StepsDetails /> },
          //   ],
          // },
          {
            path: 'training/videos',
            element: <Outlet />,
            loader: () => ({ message: 'Videos...loading' }),
            children: [
              { path: 'new', element: <AddEditTrainingVideos /> },
              { path: ':id/edit', element: <AddEditTrainingVideos editing /> },
              { path: ':id', element: <TrainingVideosDetails /> }
            ]
          },
          {
            path: 'website',
            element: (
              <TableLayout
                title="Website"
                tabs={websiteTabs}
              />
            ),
            loader: () => ({ message: 'Places...loading' }),
            children: [
              { path: 'news-items', element: <NewsItemsView /> },
              { path: 'pages', element: <PagesView /> },
              { path: 'snippets', element: <SnippetsView /> },
              { path: 'team-profiles', element: <TeamProfilesView /> },
              { path: 'feedbacks', element: <FeedbacksView /> },
              // { path: 'franchisee-leads', element: <FranchiseeLeadsView />, },
              { path: 'galleries', element: <GalleriesView /> }
            ]
          },
          {
            path: 'website/news-items',
            element: <Outlet />,
            loader: () => ({ message: 'News Items...loading' }),
            children: [
              { path: 'new', element: <AddEditNewsItem /> },
              { path: ':id/edit', element: <AddEditNewsItem editing /> },
              { path: ':id', element: <NewsItemDetails /> }
            ]
          },
          {
            path: 'website/pages',
            element: <Outlet />,
            loader: () => ({ message: 'Pages...loading' }),
            children: [
              { path: 'new', element: <AddEditPage /> },
              { path: ':id/edit', element: <AddEditPage editing /> },
              { path: ':id', element: <PageDetails /> }
            ]
          },
          {
            path: 'website/snippets',
            element: <Outlet />,
            loader: () => ({ message: 'Snippets...loading' }),
            children: [
              { path: 'new', element: <AddEditSnippet /> },
              { path: ':id/edit', element: <AddEditSnippet editing /> },
              { path: ':id', element: <SnippetDetails /> }
            ]
          },
          {
            path: 'website/team-profiles',
            element: <Outlet />,
            loader: () => ({ message: 'Team Profiles...loading' }),
            children: [
              { path: 'new', element: <AddEditTeamProfile /> },
              { path: ':id/edit', element: <AddEditTeamProfile editing /> },
              { path: ':id', element: <TeamProfileDetails /> }
            ]
          },
          {
            path: 'website/feedbacks',
            element: <Outlet />,
            loader: () => ({ message: 'Feedbacks...loading' }),
            children: [
              { path: 'new', element: <AddEditFeedback /> },
              { path: ':id/edit', element: <AddEditFeedback editing /> },
              { path: ':id', element: <FeedbackDetails /> }
            ]
          },
          // {
          //   path: "website/franchisee-leads",
          //   element: <Outlet />,
          //   loader: () => ({message: "Franchisee Leads...loading"}),
          //   children: [
          //     { path: 'new', element: <AddEditFranchiseeLead /> },
          //     { path: ':id/edit', element: <AddEditFranchiseeLead editing /> },
          //     { path: ':id', element: <FranchiseeLeadDetails /> },
          //   ]
          // },
          {
            path: 'website/galleries',
            element: <Outlet />,
            loader: () => ({ message: 'Galleries...loading' }),
            children: [
              { path: 'new', element: <AddEditGallery /> },
              { path: ':id/edit', element: <AddEditGallery editing /> },
              { path: ':id', element: <GalleryDetails /> }
            ]
          },
          {
            path: '',
            element: (
              <Navigate
                to={
                  isWebContentEditor(currentUser?.user_type_id!)
                    ? 'content/lesson-plans'
                    : 'dashboard'
                }
                replace
              />
            )
          }
        ]
      },
      {
        path: 'admins',
        element: (
          <>
            <br />
            <br />
            <Outlet />
          </>
        ),
        loader: () => ({ message: 'Admins...loading' }),
        children: [
          {
            // TODO: combine admins and instructors ( along with other Dash users)
            path: 'instructors',
            element: (
              <>
                <br />
                <br />
                <Outlet />
              </>
            ),
            children: [
              {
                path: ':id',
                element: <></>,
                loader: () => ({ message: 'Admins ...loading' })
              },
              {
                path: ':id/edit',
                element: <></>,
                loader: () => ({ message: 'Admins...loading' })
              }
            ]
          },
          {
            path: 'profile',
            element: <Profile />,
            loader: () => ({ message: 'Profile...loading' })
          }
        ]
      }
    ]
  },
  {
    path: 'users',
    element: <UserLayout />,
    loader: () => ({ message: 'Welcome...loading' }),
    children: [
      {
        path: '',
        element: <Welcome />
      },
      {
        path: 'login',
        element: <Login />,
        loader: () => ({ message: 'Login...loading' })
      },
      {
        path: 'forgot-password',
        element: <ForgotPassword />,
        loader: () => ({ message: 'Forgot password...loading' })
      },
      {
        path: 'reset-password/:token',
        element: <ResetPassword />,
        loader: () => ({ message: 'Edit password...loading' })
      },
      {
        path: 'register',
        element: <Register />,
        loader: () => ({ message: 'Register...loading' })
      }
    ]
  }
]);

const App = () => (
  <div className="App">
    <RouterProvider
      router={router}
      fallbackElement={<p>Loading...</p>}
    />
  </div>
);

export default App;
